export default {
    "title": "Disposal",
    "entityName": "disposal",
    "pagination": {
        "rowsPerPage": 10,
        "page": 1,
        "sortBy": "id",
        "descending": true
    },
    "fields": [
        {
            "value": "name",
            "text": "Name",
            "type": "text",
            "table": {
                "sortable": true,
                "filter": true
            },
            "validators": [
                "required"
            ]
        },
        {
            "value": "address",
            "text": "Address",
            "type": "text",
            "table": {
                "sortable": true,
            },
            render: item => `${item.address}, ${item.city}, ${item.cap}`,
            "validators": [
                "required"
            ]
        },
        {
            "value": "cap",
            "text": "Cap",
            "type": "text",
            "validators": [
                "required"
            ]
        },
        {
            "value": "city",
            "text": "City",
            "type": "text",
            "validators": [
                "required"
            ]
        }
    ],
    "actions": [
        "upsert", "remove",
        { "value": "references", "text": "References", "color": "primary", "icon": "mdi-contacts" },
        'audit'
    ]
}